import React, { useState, useEffect, HTMLBRElement } from "react";
import _uniqueId from "lodash/uniqueId";
import "../../Assets/Css/Components/FieldProfileUpload.css";
import Image from "../Image/image";

export default function FieldProfileUpload({
  previewUrl,
  style,
  information,
  onChange,
  required = false,
  disabled = false,
  readOnly = false,
  showButtonUpload = false,
  classNames = "",
  error,
  maxSize = 2048000000,
}) {
  useEffect(() => {
    setImagePreviewUrl(previewUrl);
  }, [previewUrl]);

  const [id] = useState(_uniqueId("field_"));
  const [imagePreviewUrl, setImagePreviewUrl] = useState(previewUrl);
  const [localError, setLocalError] = useState([]);

  const handlePhotoUpload = (e) => {
    e.preventDefault();
    const file = e.target.files[0];

    if (file) {
      const errors = [];
      if (file.size > maxSize) {
        errors.push({ message: "Max file size is " + maxSize });
        setLocalError(errors);
      } else if (file.type.split("/")[0] != "image") {
        errors.push({ message: "You must select an image file." });
        setLocalError(errors);
      } else {
        const reader = new FileReader();
        reader.onloadend = () => {
          onChange(file);
          setImagePreviewUrl(reader.result);
          setLocalError([]);
        };

        reader.onerror = (e) => {
          alert("Erro");
          errors.push(e.message);
          setLocalError(errors);
        };

        reader.readAsDataURL(file);
      }
    }
  };

  return (
    <>
      <div className={"form-group " + classNames} style={{ textAlign: "center", ...style }}>
        <label htmlFor={id} className="custom-file-upload fas">
          <div className="img-wrap img-upload">
            {/* <Image src={imagePreviewUrl} defaultSrc={profile} radius="50%" /> */}
            <Image src={imagePreviewUrl} radius="50%" />
          </div>
          <input id={id} type="file" className="fieldUpload" onChange={handlePhotoUpload} required={required} disabled={disabled} readOnly={readOnly} accept="image/*" />
        </label>

        {information ? (
          <small id={id + "Help"} className="form-text text-muted">
            {information}
          </small>
        ) : null}
        {error || localError?.length > 0 ? (
          <div className="invalid-feedback" style={{ display: "block" }}>
            <ul>
              {error ? <li>{error}</li> : null}
              {localError?.length > 0 ? localError.map((x, index) => <li key={index}>{x.message}</li>) : null}
            </ul>
          </div>
        ) : null}
      </div>

      {showButtonUpload && (
        <div className="profile-avatar-column">
          <div className="profile-avatar-row">
            <label className="btn btn-dark" variant="dark">
              Upload new image
              <input id={id} type="file" className="fieldUpload" onChange={handlePhotoUpload} required={required} disabled={disabled} readOnly={readOnly} accept="image/*" />
            </label>
          </div>
          <small className="profile-avatar-row">At least 800x800 px recommended. JPG or PNG and GIF is allowed</small>
        </div>
      )}
    </>
  );
}
